/* eslint-disable */
export default {
  download: 'ダウンロード',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
